import SimpleForm, { IActionButton } from "./SimpleForm";

export default SimpleForm
export type { IActionButton }